import { Component } from '@angular/core';
import { AttributesContainer } from '../../../shared/components/attributes-container/attributes-container';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { LoaderService } from '../../../services/loader-service';

interface AttributeItem {
  title: string;
  icon: string;
  description: string;
}
@Component({
  selector: 'app-about-us',
  imports: [...TRANSLATIONS_IMPORTS],
  templateUrl: './about-us.html',
  styleUrl: './about-us.scss',
})
export class AboutUs {

  constructor(
    public loaderService: LoaderService,
  ){

  }
  ATTRIBUTES: AttributeItem[] = [
    {
      title: 'Track Indicators',
      icon: 'target',
      description:
        'Monitor key performance indicators against defined targets to measure progress and impact.',
    },
    {
      title: 'Data Collection',
      icon: 'data-collection',
      description:
        'Capture, validate, and manage data from multiple sources in a structured and secure way.',
    },
    {
      title: 'Visual Analytics',
      icon: 'visual-analytics',
      description:
        'Transform raw data into interactive dashboards and insights for informed decision-making.',
    },
    {
      title: 'Real Time Updates',
      icon: 'realtime',
      description: 'Access up-to-date metrics and system changes instantly as data is submitted.',
    },
  ];
}
